import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'shards-react';
import PageTitle from '../PageTitle';

const CompareDocumentsIFramePage = ({ match }) => {
	return (
		<Container fluid className='main-content-container px-4'>
			<PageTitle sm='4' title='' subtitle='Dokumente vergleichen' className='text-sm-left' />
			<Row>
				<Col>
					<Card small>
						<CardBody>
							<iframe src={`https://dev-master.synop.de/compareIframeContent/render?jobId=${match.params.jobId}`} className='compareIframe' title='compareIframe' />
						</CardBody>
					</Card>
				</Col>
			</Row>
		</Container>
	);
};

export default CompareDocumentsIFramePage; //Export component and connect it with redux.
